import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5 pb-3" }
const _hoisted_2 = { class: "flex flex-col mb-3" }
const _hoisted_3 = { class: "flex flex-col mb-3" }
const _hoisted_4 = { class: "flex flex-col mb-3" }
const _hoisted_5 = { class: "col-span-3" }
const _hoisted_6 = { class: "whitespace-nowrap" }
const _hoisted_7 = { class: "grid grid-cols-8 gap-3 mb-3" }
const _hoisted_8 = { class: "col-span-6 flex flex-col" }
const _hoisted_9 = { class: "col-span-2 flex flex-col" }
const _hoisted_10 = { class: "flex flex-col mb-3" }
const _hoisted_11 = { class: "flex flex-col mb-3" }
const _hoisted_12 = { class: "flex flex-col mb-3" }
const _hoisted_13 = { class: "flex flex-col mb-3" }
const _hoisted_14 = { class: "flex flex-col mb-3" }
const _hoisted_15 = { class: "flex flex-col mb-3" }
const _hoisted_16 = { class: "col-start-1 flex flex-col mb-3" }
const _hoisted_17 = { class: "flex flex-col mb-3" }
const _hoisted_18 = { class: "flex flex-col mb-3" }
const _hoisted_19 = { class: "flex flex-col mb-3" }
const _hoisted_20 = { class: "flex flex-col mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_MapViewer = _resolveComponent("MapViewer")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[21] || (_cache[21] = _createElementVNode("h6", { class: "px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray" }, "Denominazione", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Field, {
        field_name: "Denominazione",
        "model-value": _ctx.denominazione,
        "input-attrs": {disabled:_ctx.disabled},
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:denominazione', $event))),
        required: !_ctx.denominazione && !_ctx.disabled,
        errors: _ctx.getErrors('denominazione')
      }, null, 8, ["model-value", "input-attrs", "required", "errors"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Field, {
        field_name: "Sito web",
        "model-value": _ctx.sito,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:sito', $event))),
        required: (!_ctx.anagrafica_denominazione_id || _ctx.anagrafica_denominazione_id == -1) && !_ctx.disabled && !_ctx.sito,
        "input-attrs": {disabled:_ctx.disabled},
        errors: _ctx.getErrors('sito')
      }, null, 8, ["model-value", "required", "input-attrs", "errors"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Field, {
        field_name: "Gruppo di appartenenza",
        "model-value": _ctx.gruppo_di_appartenenza,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:gruppo_di_appartenenza', $event))),
        "input-attrs": {disabled:_ctx.disabled},
        errors: _ctx.getErrors('gruppo_di_appartenenza')
      }, null, 8, ["model-value", "input-attrs", "errors"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_MapViewer, {
        placeId: _ctx.place_id,
        lat: _ctx.lat,
        lng: _ctx.lng,
        readonly: _ctx.disabled,
        "onUpdate:placeId": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:place_id', $event))),
        "onUpdate:lat": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:lat', $event))),
        "onUpdate:lng": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:lng', $event))),
        onAddressInformationChange: _ctx.onAddressInformationChange
      }, {
        actual: _withCtx(({actual}) => [
          _createElementVNode("p", _hoisted_6, [
            _cache[20] || (_cache[20] = _createTextVNode("Selezione attuale: ")),
            _createElementVNode("b", null, _toDisplayString(actual?.formatted_address || '----'), 1)
          ])
        ]),
        _: 1
      }, 8, ["placeId", "lat", "lng", "readonly", "onAddressInformationChange"])
    ]),
    (!_ctx.disabled)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Field, {
          field_name: "Sede operativa via",
          "model-value": _ctx.sede_operativa_via,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:sede_operativa_via', $event))),
          "input-attrs": {disabled:_ctx.disabled},
          errors: _ctx.getErrors('sede_operativa_via'),
          placeholder: "Nome via"
        }, null, 8, ["model-value", "input-attrs", "errors"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Field, {
          field_name: "numero",
          "model-value": _ctx.sede_operativa_numero,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update:sede_operativa_numero', $event))),
          "input-attrs": {disabled:_ctx.disabled},
          errors: _ctx.getErrors('sede_operativa_numero'),
          placeholder: "00"
        }, null, 8, ["model-value", "input-attrs", "errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_Field, {
        field_name: "Sede operativa nazione",
        errors: _ctx.getErrors('sede_operativa_nazione_id')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            disabled: _ctx.disabled,
            modelValue: _ctx.so.na_selection,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.so.na_selection) = $event)),
            options: _ctx.so.na_options,
            placeholder: "Nazione",
            class: "next-vue-multiselect-single",
            "track-by": "id",
            label: "codice",
            selectLabel: "",
            deselectLabel: "",
            selectedLabel: "",
            "internal-search": false,
            onSearchChange: _ctx.so.na_search
          }, {
            option: _withCtx(({option}) => [
              _createTextVNode(_toDisplayString(option.codice) + " - " + _toDisplayString(option.nome), 1)
            ]),
            _: 1
          }, 8, ["disabled", "modelValue", "options", "onSearchChange"])
        ]),
        _: 1
      }, 8, ["errors"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_Field, {
        field_name: "Sede operativa cap",
        "model-value": _ctx.sede_operativa_cap,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:sede_operativa_cap', $event))),
        "input-attrs": {disabled:_ctx.disabled},
        errors: _ctx.getErrors('sede_operativa_cap'),
        placeholder: "CAP"
      }, null, 8, ["model-value", "input-attrs", "errors"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _createVNode(_component_Field, {
        required: false,
        field_name: "Sede operativa provincia",
        errors: _ctx.getErrors('sede_operativa_provincia_id')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            disabled: _ctx.disabled,
            modelValue: _ctx.so.pa_selection,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.so.pa_selection) = $event)),
            options: _ctx.so.pa_options,
            placeholder: "Prov.",
            class: "next-vue-multiselect-single",
            "track-by": "id",
            label: "codice",
            selectLabel: "",
            deselectLabel: "",
            selectedLabel: "",
            "internal-search": false,
            onSearchChange: _ctx.so.pa_search
          }, null, 8, ["disabled", "modelValue", "options", "onSearchChange"])
        ]),
        _: 1
      }, 8, ["errors"])
    ], 512), [
      [_vShow, _ctx.so.isNazioneItalia]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _createVNode(_component_Field, {
        errors: _ctx.getErrors('sede_operativa_comune_id'),
        field_name: "Sede operativa comune"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VueMultiselect, {
            disabled: _ctx.disabled,
            modelValue: _ctx.so.ca_selection,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.so.ca_selection) = $event)),
            options: _ctx.so.ca_options,
            onTag: _cache[12] || (_cache[12] = (value)=>_ctx.so.ca_add({id:-1, nome:value})),
            placeholder: "Comune",
            class: "next-vue-multiselect-single",
            "track-by": "id",
            label: "nome",
            selectLabel: "",
            deselectLabel: "",
            selectedLabel: "",
            "internal-search": false,
            onSearchChange: _ctx.so.ca_search
          }, null, 8, ["disabled", "modelValue", "options", "onSearchChange"])
        ]),
        _: 1
      }, 8, ["errors"])
    ], 512), [
      [_vShow, _ctx.so.isNazioneItalia]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_14, [
      _createVNode(_component_Field, {
        field_name: "Sede operativa regione estera",
        "model-value": _ctx.sede_operativa_regione_estero,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('update:sede_operativa_regione_estero', $event))),
        "input-attrs": {disabled:_ctx.disabled},
        errors: _ctx.getErrors('sede_operativa_regione_estero'),
        placeholder: "Regione estera"
      }, null, 8, ["model-value", "input-attrs", "errors"])
    ], 512), [
      [_vShow, !_ctx.so.isNazioneItalia]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_15, [
      _createVNode(_component_Field, {
        field_name: "Sede operativa città estera",
        "model-value": _ctx.sede_operativa_citta_estero,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('update:sede_operativa_citta_estero', $event))),
        "input-attrs": {disabled:_ctx.disabled},
        errors: _ctx.getErrors('sede_operativa_citta_estero'),
        placeholder: "Città estera"
      }, null, 8, ["model-value", "input-attrs", "errors"])
    ], 512), [
      [_vShow, !_ctx.so.isNazioneItalia]
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_Field, {
        field_name: "Email",
        type: "email",
        "model-value": _ctx.email,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('update:email', $event))),
        "input-attrs": {disabled:_ctx.disabled},
        errors: _ctx.getErrors('email'),
        placeholder: "Email"
      }, null, 8, ["model-value", "input-attrs", "errors"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_Field, {
        field_name: "Email pec",
        type: "email",
        "model-value": _ctx.pec,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('update:pec', $event))),
        "input-attrs": {disabled:_ctx.disabled},
        errors: _ctx.getErrors('pec'),
        placeholder: "Email pec"
      }, null, 8, ["model-value", "input-attrs", "errors"])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_Field, {
        field_name: "Telefono 1",
        "model-value": _ctx.telefono_1,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('update:telefono_1', $event))),
        "input-attrs": {disabled:_ctx.disabled},
        errors: _ctx.getErrors('telefono_1'),
        placeholder: "Telefono"
      }, null, 8, ["model-value", "input-attrs", "errors"])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_Field, {
        field_name: "Telefono 2",
        "model-value": _ctx.telefono_2,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('update:telefono_2', $event))),
        "input-attrs": {disabled:_ctx.disabled},
        errors: _ctx.getErrors('telefono_2'),
        placeholder: "Telefono"
      }, null, 8, ["model-value", "input-attrs", "errors"])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_Field, {
        field_name: "Fax",
        "model-value": _ctx.fax,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('update:fax', $event))),
        "input-attrs": {disabled:_ctx.disabled},
        errors: _ctx.getErrors('fax'),
        placeholder: "Fax"
      }, null, 8, ["model-value", "input-attrs", "errors"])
    ])
  ]))
}